import ScrollDir from "./scrollDir";

const d = document;

export class fixNav {
  constructor( selector, classname='is-active' ){
    new ScrollDir();
    this.elm = d.querySelector(selector);
    if(this.elm) this.addclass(classname);
  }

  addclass(classname) {
    d.addEventListener('Scroll.scrollUp', () => this.elm.classList.add(classname) );
    d.addEventListener('Scroll.scrollDown', () => this.elm.classList.remove(classname) );
  }

}